// extracted by mini-css-extract-plugin
module.exports = {"loaderActions":"Loader_loaderActions__387o5","solid":"Loader_solid__8pN_C","outlined":"Loader_outlined__32eZN","pendingImg":"Loader_pendingImg__3GkEg"};